import styled from 'styled-components';

export const StyledContainer = styled.div`
  padding-left: 40%;
  padding-top: 15%;
`;
